import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Tag, Button, Upload, Tooltip, Form, Empty, Image, Input } from "antd";
import { DownloadOutlined, PlusOutlined, UploadOutlined, DeleteOutlined } from '@ant-design/icons';
const { TextArea } = Input
import InspectionApi from '@api/inspectionnew'
import { stationApi, } from "@api/newApi";
import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import { getStationData, toolMouseTip } from '@utils/common'
import AddModel from './add'
import '../style.scss'
import './index.scss'

const StatusData = ['', '执行中', '完成', '未完成']
const colorStatus = ['', '#2db7f5', '#87d068', '#FF3819']

const OrderCom = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editTitle] = useState('新增保养任务')
  const [rowParams, setRowParams] = useState()
  const [acceptVisible, setAcceptVisible] = useState(false)
  const [checkacceptVisible, setCheckacceptVisible] = useState(false)
  const [visible, setVisible] = useState(false)
  const [complateId, setComplateId] = useState()
  const [detailModal, setDetailModal] = useState(false)
  const [detail, setDetail] = useState({})
  const [imageUrls, setImageUrls] = useState([])
  const [detailImages, setDetailImages] = useState([])

  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)


  // 搜索
  const [inputList] = useState([{
    label: '保养任务名称:',
    name: "upkeepTaskName",
    message: "请输入保养任务名称",
    span: 8,
    labelCol: 6
  }, {
    label: '设备名称:',
    name: "deviceName",
    message: "请输入设备名称",
    span: 8,
    labelCol: 6
  }, {
    label: '执行角色:',
    name: "handleUser",
    message: "请输入执行角色",
    span: 8,
    labelCol: 6
  }])


  const [selectList, setSelectList] = useState()

  const [stationData, setStationData] = useState()


  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    const data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '厂站:',
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6
      },
    ])
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    InspectionApi.upkeepQuery({ ...searchParams }).then(res => {
      setLoading(false)
      setData(res.data?.data)
      setTotal(res.data?.total)
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = (id) => {
    setLoadBtn(true)
    InspectionApi.delete(id).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancel = () => {
    setDelVisible(false)
    setAcceptVisible(false)
    setCheckacceptVisible(false)
    form.resetFields();
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (info) => {
    InspectionApi.defectLevelDel({ id: info.id }).then(res => {
      if (res.status == '0') {
        message.success('删除成功')
        listByRole()
      }
    })
  }
  // 关闭工单
  const handleClose = (id) => {
    InspectionApi.closeDefectOrder(id).then(res => {
      if (res.status == 0) {
        message.success('关闭成功')
        listByRole()
      }
    })
  }

  // 上传前进行图片限制处理
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('图片格式不正确!');
    }
    const isLt2M = file.size / 1024 / 1024 < 7;
    if (!isLt2M) {
      message.error('图片最大7M!');
    }
    return isJpgOrPng && isLt2M;
  }

  const uploadResultImg = (info) => {
    const { file } = info
    if (file.status === 'done') {
      const { response: res } = file
      if (res.status !== '0') return
      setImageUrls([...imageUrls, res.data.url])
    }
  }

  const removeResultImg = (info) => {
    const { response: res } = info
    const url = res.data.url
    const params = imageUrls
    const index = params.findIndex(item => item === url)
    params.splice(index, 1)
    setImageUrls([...params])
  }

  // 接受工单
  const accept = () => {
    form.validateFields().then(values => {
      if (!values) {
        return;
      }
      InspectionApi.defectAccept({ id: rowParams.id, planCloseTime: values.planCloseTime }).then(res => {
        if (res.status == 0) {
          message.success('接受成功')
          listByRole()
          setAcceptVisible(false)
        }
      })
    })

  }
  //验收
  const checkaccept = () => {
    form.validateFields().then(values => {
      if (!values) {
        return;
      }
      InspectionApi.checkAccept({ id: rowParams.id, deffectRemark: values.deffectRemark }).then(res => {
        if (res.status == 0) {
          message.success('接受成功')
          listByRole()
          setAcceptVisible(false)
        }
      })
    })
  }

  // 转工单
  const handleOrder = (record) => {
    console.log('123123123')
    setEditVisible(true)
    setRowParams(record)
  }

  const UploadPropsprops = {
    name: 'file',
    action: window.globalConfig.UPLOADER,
    headers: {
      authorization: sessionStorage.getItem('token'),
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        console.log(info.file)
        message.success(`${info.file.name}上传成功`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name}上传失败`);
      }
    },
  };

  const normFile = (e) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const submit = () => {
    form.validateFields().then(values => {
      if (!values) return
      const params = {
        id: complateId,
        images: imageUrls.join(','),
        mark: values.mark
      }
      InspectionApi.upkeepTaskFinish(params).then(res => {
        if (res.status !== '0') return
        message.success('提交成功')
        form.resetFields()
        setVisible(false)
        listByRole()
      })
    })
  }

  const showDetail = (id) => {
    InspectionApi.upkeepTaskGetDetail({ id }).then(res => {
      setDetail(res.data)
      if (res.data.images) {
        setDetailImages(res.data.images.split(','))
      }
      setDetailModal(true)
    })
  }


  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    visible: true,
    onClick: () => {
      setRowParams(null)
      setEditVisible(true)
    }
  }]

  const columns = [
    {
      title: '名称',
      dataIndex: 'taskName',
      align: 'center',
      key: 'taskName',
      render: _t => toolMouseTip(_t, 6)
    },
    {
      title: '设备',
      dataIndex: 'deviceName',
      align: 'center',
      key: 'deviceName',
    },
    {
      title: '保养内容',
      dataIndex: 'itemContent',
      align: 'center',
      key: 'itemContent',
      render: _t => toolMouseTip(_t, 6)
    },
    {
      title: '执行人',
      dataIndex: 'finishByName',
      align: 'center',
      key: 'finishByName',
      render: _t => _t || '-'
    },
    {
      title: '执行角色',
      dataIndex: 'handleUserName',
      align: 'center',
      key: 'handleUserName',
    },
    {
      title: '厂站',
      dataIndex: 'stationName',
      align: 'center',
      key: 'stationName',
    },
    {
      title: '周期',
      dataIndex: 'period',
      align: 'center',
      key: 'period',
    },
    {
      title: '状态',
      dataIndex: 'handleStatus',
      align: 'center',
      key: 'handleStatus',
      render: val => <Tag color={colorStatus[val - 0]}>{StatusData[val - 0]}</Tag>
    },
    {
      title: '开始时间',
      dataIndex: 'beginTime',
      align: 'center',
      key: 'beginTime',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      align: 'center',
      key: 'endTime',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '操作',
      key: 'operation',
      fixed: 'right',
      render: (obj, record) => {
        return (
          <>
            {
              props.userInfo.btnResources.indexOf('upkeep:task:submit') !== -1 &&
              record.handleStatus === 1 && <Button className='success' size='small' type='primary' onClick={() => {
                setComplateId(record.id)
                setVisible(true)
              }}>提交
              </Button>
            }
            {
              props.userInfo.btnResources.indexOf('upkeep:task:info') !== -1 &&
              <Button type='primary' size='small' style={{ marginLeft: 10 }} onClick={() => { showDetail(record.id) }}>详情</Button>
            }
          </>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        <div style={{ marginLeft: '24px' }}>
          <SearchForm span={6} inputList={inputList} selectList={selectList} onSearch={search} />
        </div>
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {
          visible && <Modal
            title="完成保养任务"
            open={visible}
            onCancel={() => {
              setVisible(false)
              form.resetFields()
            }}
            onOk={() => submit()}>
            <Form
              form={form}
              autoComplete="off"
            >
              <Form.Item
                label="备注"
                name="mark"
                rules={[
                  {
                    required: true,
                    message: '请输入备注',
                  },
                ]}
              >
                <TextArea rows={3} placeholder="请输入备注" />
              </Form.Item>
              <Form.Item
                label='图片'
              >
                <Upload
                  name='file'
                  action={window.globalConfig.UPLOADER}
                  headers={{ authorization: sessionStorage.getItem('token') }}
                  beforeUpload={(e) => beforeUpload(e)}
                  onChange={(e) => uploadResultImg(e)}
                  onRemove={e => removeResultImg(e)}
                >
                  <Button icon={<UploadOutlined />}>上传图片</Button>
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
        }
        <Modal
          title="详情"
          open={detailModal}
          onOk={() => setDetailModal(false)}
          onCancel={() => setDetailModal(false)}
        >
          <div className='upkeep-task-detail'>
            <ul>
              <li>任务名称：{detail.taskName}</li>
              <li>设备名称：{detail.deviceName}</li>
              <li>保养内容：{detail.itemContent}</li>
              <li>执行人：{detail.finishByName || '-'}</li>
              <li>执行角色：{detail.handleUserName}</li>
              <li>周期：{detail.period}</li>
              <li>油量：{detail.oliMass}</li>
              <li>油脂：{detail.grease}</li>
              <li>备注：{detail.mark}</li>
              <li>厂站名称：{detail.stationName}</li>
              <li>创建时间：{moment(detail.createAt).format('YYYY-MM-DD HH:mm:ss')}</li>
              <li>开始时间：{moment(detail.beginTime).format('YYYY-MM-DD HH:mm:ss')}</li>
              <li>结束时间：{moment(detail.endTime).format('YYYY-MM-DD HH:mm:ss')}</li>
              <li>图片展示：
                {
                  detailImages && detailImages.length > 0 ? <div className='defect-detail-item-imglist'>
                    {
                      detailImages.map((item, index) => {
                        return (
                          <Image
                            key={index}
                            width={100}
                            src={item}
                          />
                        )
                      })
                    }
                  </div> : <Empty description="暂无图片" />
                }
              </li>
            </ul>
          </div>
        </Modal>
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(OrderCom)
